import { render } from "./TermsModal.vue?vue&type=template&id=620f13b4"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=620f13b4&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__